var _ellipse, _circle, _path, _path2, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.5,
    cy: 139.5,
    rx: 44.5,
    ry: 6.5,
    fill: "url(#paint0_radial_309_13532)",
    fillOpacity: 0.2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 100,
    cy: 100,
    r: 89,
    fill: "url(#paint1_radial_309_13532)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.646 56.1225L149.798 64.2854L149.693 64.8857L152.262 66.5237L148.48 69.3847C147.984 69.774 147.313 69.7997 146.799 69.4721C146.285 69.1445 146.004 68.5721 146.117 67.9256L146.504 65.7091L146.955 63.1232L147.02 62.7538C147.052 62.5691 147.131 62.3924 147.293 62.2781L147.998 61.7825L157.707 54.9594C158.032 54.7307 158.494 54.8113 158.731 55.0905C158.959 55.4159 158.925 55.8858 158.646 56.1225Z",
    fill: "#FFC043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M165.545 48.7616C165.95 49.1654 166.085 49.7599 165.896 50.2979L159.588 68.9917C159.461 69.4455 159.119 69.7665 158.664 69.9249C158.254 70.0913 157.738 70.0488 157.354 69.7916L149.693 64.8857L149.798 64.2854L158.646 56.1225C158.925 55.8858 158.959 55.4159 158.731 55.0905C158.448 54.8032 158.032 54.7307 157.707 54.9594L147.988 62.1138L147.229 62.6475C147.066 62.7618 146.988 62.9385 146.955 63.1232L145.705 62.3815L140.912 59.3086C140.444 58.9891 140.155 58.4628 140.26 57.8625C140.311 57.3003 140.676 56.8408 141.233 56.6523L163.983 48.4414C164.493 48.245 165.14 48.3578 165.545 48.7616Z",
    fill: "#FFC043"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 83,
    r: 1,
    fill: "#EDEBFD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.5,
    cy: 38,
    r: 1,
    fill: "#EDEBFD"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.5,
    cy: 133,
    r: 3,
    fill: "#EDEBFD"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 150,
    r: 2,
    fill: "#EDEBFD"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 47,
    r: 3,
    fill: "#EDEBFD"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.9999,
    cy: 123.5,
    r: 0.5,
    fill: "#EDEBFD"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 119,
    r: 1,
    fill: "#EDEBFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.818 132.817C121.693 132.817 114.349 128.599 110.286 121.567C106.224 114.692 106.224 106.099 110.286 99.0674C114.349 92.1924 121.693 87.8174 129.818 87.8174C137.786 87.8174 145.13 92.1924 149.193 99.0674C153.255 106.099 153.255 114.692 149.193 121.567C145.13 128.599 137.786 132.817 129.818 132.817ZM140.286 107.192C141.224 106.255 141.224 104.536 140.286 103.599C139.349 102.661 137.63 102.661 136.693 103.599L127.318 113.13L122.786 108.599C121.849 107.661 120.13 107.661 119.193 108.599C118.255 109.536 118.255 111.255 119.193 112.192L125.443 118.442C126.38 119.38 128.099 119.38 129.036 118.442L140.286 107.192Z",
    fill: "#276EF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M52.3175 75.3174C52.3175 71.2549 55.5988 67.8174 59.8175 67.8174H124.818C128.88 67.8174 132.318 71.2549 132.318 75.3174C132.318 77.8174 131.068 80.0049 129.193 81.4111L127.005 82.9736C116.693 84.0674 107.943 90.7861 104.193 100.161L95.2863 106.88C93.4113 108.286 91.0675 108.286 89.1925 106.88L55.2863 81.4111C53.4113 80.0049 52.3175 77.8174 52.3175 75.3174ZM102.318 107.817C102.318 108.599 102.318 109.536 102.318 110.317C102.318 117.036 104.661 123.13 108.568 127.817H62.3175C56.6925 127.817 52.3175 123.442 52.3175 117.817V85.3174L86.2238 110.942C89.8175 113.599 94.6613 113.599 98.255 110.942L102.318 107.817Z",
    fill: "#276EF1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_309_13532",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.5 139.5) rotate(90) scale(6.5 44.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5144A6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8238BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_309_13532",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100 100) rotate(90) scale(89)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEEFE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterSuccess);
export default __webpack_public_path__ + "static/media/_register-success.3f549022521c31334d05c9bf151e06de.svg";
export { ForwardRef as ReactComponent };